<div class="root-container">
  <div 
  class="form-group">
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <label 
        class="mb-2">E-Signature </label>
        @if (editing()) {
          <div
            [class.blur]="isProcessing()"
          >
            <image-picker
              [url]="image()"
              accepts='.jpg , .jpeg , .png'
              [max_size]="5242880"
              (fileUpload)="onFileChange($event)"
            >
              <div class="image-desc">(jpg jpeg png) (5MB)</div>
            </image-picker>
          </div>
        } @else {
          <div 
          class="d-flex justify-content-center"
          style="height: 200px;"
          >
            <img 
            style="height: 100%;"
            [src]="image() || 'assets/images/defaults/default_image.png'" 
            alt="default_image">
          </div>
        }
        <p>Note: Uploaded E-Signature will be used in generated documents. Please use an image with black sign and white background.</p>
      </div>
    </div>
  </div>
</div>
